const urLang = {
    job_card_invoice_open_failed: "انوائس فارم نہیں کھل سکا۔ دوبارہ کوشش کریں؛ کوئی انوائس نہیں بنائی گئی۔",
    quotation_item_type_unclassified: "انوائس یا جاب کارڈ میں تبدیل کرنے سے پہلے پرانے کوٹیشن کی اشیاء کا جائزہ لے کر ان کی درجہ بندی کریں۔ اصل اشیاء محفوظ ہیں۔",
    profit_report_filter_invalid: "درست ابتدا اور اختتام کی تاریخیں اور سپروائزر منتخب کریں۔",
    profit_report_load_failed: "منافع کی رپورٹ لوڈ نہیں ہوئی۔ آخری تصدیق شدہ نتیجہ برقرار ہے۔",
    profit_report_supervisor_note: "الگ انوائسیں سب کے تحت نظر آتی ہیں کیونکہ ان کے ساتھ سیلز سپروائزر منسلک نہیں ہے۔",

    work_report_load_failed: "کام کی رپورٹ لوڈ نہیں ہوئی۔ تاریخیں چیک کر کے دوبارہ کوشش کریں۔",
    work_report_totals_note: "کئی ٹیکنیشن ہونے پر ہر خدمت کی قیمت کل میں ایک بار شمار ہوتی ہے۔ ڈیش کا مطلب ہے کہ گھنٹے درج نہیں ہیں۔",

    purchase_return_source_rows_only: "واپسی اصل خریداری کی قطاروں سے منسلک ہونی چاہیے۔ مقدار تبدیل کر کے محفوظ کریں۔",
    purchase_return_stock_invalid: "اس واپسی کے لیے دستیاب اسٹاک یا اس کی قدر ناکافی ہے۔",
    purchase_return_quantity_invalid: "واپسی کی مثبت مقدار باقی خریدی ہوئی مقدار سے زیادہ نہ ہو۔",
    purchase_return_source_unposted: "واپسی سے پہلے اصل خریداری بل پوسٹ کریں۔",
    purchase_return_source_invalid: "واپسی سے پہلے اصل خریداری کا ڈیٹا جانچیں۔",
    purchase_return_source_journal_invalid: "واپسی سے پہلے اصل خریداری کے جرنل کا جائزہ لیں۔",
    purchase_return_source_link_missing: "اس پرانی واپسی کا خریداری کی قطاروں سے تصدیق شدہ تعلق موجود نہیں۔",
    purchase_return_has_later_returns: "پہلے ان خریداری کی قطاروں کی بعد کی واپسی منسوخ کریں۔",
    purchase_return_request_changed: "یہ درخواست مختلف ڈیٹا کے ساتھ محفوظ ہو چکی ہے۔ نئی واپسی سے پہلے فہرست تازہ کریں۔",
    purchase_return_request_required: "واپسی کا فارم دوبارہ کھول کر کوشش کریں۔",
    purchase_return_write_failed: "واپسی محفوظ نہیں ہوئی۔ دوبارہ کوشش کے لیے اندراجات برقرار ہیں۔",
    post_purchase_return_note: "پوسٹنگ منسوخ کرنے سے اسٹاک، اصل بل کی مقدار، جرنل اور منسلک رقم واپسی بحال ہو گی۔ جاری رکھیں؟",

    post_purchase_note: "پوسٹنگ ختم کرنے سے بل مسودہ بن جائے گا اور متعلقہ اسٹاک، جرنل اور ادائیگی واپس ہو جائیں گے۔ کیا آپ جاری رکھنا چاہتے ہیں؟",
    purchase_action_failed: "عمل کی کامیابی کی تصدیق نہیں ہو سکی۔ دوبارہ کوشش سے پہلے صفحہ تازہ کریں۔",
    purchase_load_failed: "خریداری کے بل لوڈ نہیں ہو سکے۔ دوبارہ کوشش کریں۔",
    purchase_account_mapping_required: "پوسٹ کرنے سے پہلے خریداری کے اکاؤنٹس کی ترتیب چیک کریں۔",
    purchase_has_returns: "واپسی والے بل کی پوسٹنگ تبدیل نہیں کی جا سکتی۔",
    purchase_has_later_stock_movements: "اس بل کی پوسٹنگ ختم کرنے سے پہلے بعد کی اسٹاک حرکات واپس کریں۔",
    purchase_stock_history_missing: "اصل اسٹاک حرکت کا جائزہ لینے کے بعد ہی پوسٹنگ ختم ہو سکتی ہے۔",
    purchase_state_changed: "بل کی حالت بدل گئی ہے۔ صفحہ تازہ کریں۔",
    catalogue_load_failed: "اشیاء کی فہرست لوڈ نہیں ہو سکی۔ دوبارہ کوشش کریں۔",
    report_export_failed: 'رپورٹ تیار نہیں ہو سکی۔ دوبارہ کوشش کریں۔',
    are_you_sure_delete: 'کیا آپ واقعی {name} کو حذف کرنا چاہتے ہیں؟',
langname: 'ur',
    item_code_required: 'آئٹم کوڈ ہمیشہ ضروری ہے',
    item_name_required: 'نام کے بغیر آئٹم شامل نہیں کیا جا سکتا',
    this_product_already_exist: 'یہ پروڈکٹ پہلے سے موجود ہے',
    confirm_delete: 'کیا آپ واقعی یہ اکاؤنٹ حذف کرنا چاہتے ہیں؟',
    product_save_failed: 'آئٹم محفوظ نہیں ہو سکا۔ دوبارہ کوشش کریں یا سپورٹ سے رابطہ کریں',
dir: 'rtl',
ldir: 'ltr',
algin: 'right',
lalgin: 'left',

invoiceno: 'انوائس نمبر',
plate_number: 'گاڑی نمبر',
main_menu: 'مین مینو',
search: 'search',
invoices: 'انوائسز',
add_invoice: 'شامل کریں',
invtype: 'انوائس کی قسم',
customer: 'گاہک',
mobile: 'موبائل',
plate: 'نمبر پلیٹ',
model: 'ماڈل',
inv_date: 'تاریخ',
total: 'کل رقم',
vat: 'وی اے ٹی',
ftotal: 'وی اے ٹی سمیت کل',
paid: 'ادا شدہ',
remain: 'باقی',
remain_amount: 'باقی رقم',
action: 'عمل',
status: 'حالت',
view: 'دیکھیں',
totals: 'کل',
close: 'بند کریں',

customer_name: 'گاہک کا نام',
customer_type: 'گاہک کی قسم',
company_name: 'کمپنی کا نام',
comapny_address: 'کمپنی کا پتہ',
company_vatid: 'وی اے ٹی نمبر',

car_model: 'گاڑی کا ماڈل',
car_year: 'بنانے کا سال',
car_color: 'رنگ',

invoice_type: 'انوائس کی قسم',
vat_type: 'وی اے ٹی کی قسم',
payment_method: 'ادائیگی کا طریقہ',
saler_name: 'سیلز مین کا نام',
invoice_date: 'انوائس کی تاریخ',
invoice_details: 'انوائس کی تفصیل',

item_code: 'آئٹم کوڈ',
description: 'تفصیل',
qtty: 'مقدار',
item_price: 'آئٹم کی قیمت',
discount: 'ڈسکاؤنٹ',

create_invoice: 'انوائس بنائیں',
cash_payment: 'نقد ادائیگی',
span_payment: 'اسپین ادائیگی کا طریقہ',
add: 'شامل کریں',

individual_client: 'انفرادی گاہک',
company_clinet: 'کارپوریٹ گاہک',

prices_include_vat: 'قیمتیں وی اے ٹی سمیت',
prices_exclusive_vat: 'قیمتیں وی اے ٹی کے بغیر',
prices_without_vat: 'وی اے ٹی کے بغیر',

none_paid_invoice: 'غیر ادا شدہ انوائس',
paid_invoice: 'ادا شدہ انوائس',

bank_payment: 'بینک ٹرانسفر',
multi_payments: 'متعدد ادائیگی طریقے',

required_field: 'یہ فیلڈ ضروری ہے',
you_can_not_add_empty_invoice: 'خالی انوائس شامل نہیں کی جا سکتی',

company_ifnormation_required: 'کمپنی کی معلومات درکار ہیں - نام، پتہ، کمرشل رجسٹریشن نمبر',

invoice_added: 'انوائس شامل کر دی گئی',

can_not_add_item_withoud_discription: 'تفصیل کے بغیر آئٹم شامل نہیں کیا جا سکتا',

item_qtty_must_be_more_than_zero: 'آئٹم کی مقدار صفر نہیں ہو سکتی',

item_price_must_be_more_than_zero: 'آئٹم کی قیمت صفر نہیں ہو سکتی',

print_invoice: 'انوائس پرنٹ کریں',
view_pdf: 'پی ڈی ایف دیکھیں',

invoice_return: 'انوائس واپس کریں',

make_payment: 'ادائیگی کریں',

invoice_tme: 'انوائس وقت',
return_date: 'واپسی کی تاریخ',
return_time: 'واپسی کا وقت',
return_case: 'واپسی کی وجہ',

total_exclusive_vat: 'وی اے ٹی کے بغیر کل رقم',
total_include_vat: 'وی اے ٹی سمیت کل رقم',

payments: 'ادائیگیاں',
payment_date: 'ادائیگی کی تاریخ',
payment_time: 'ادائیگی کا وقت',
payment_amount: 'ادائیگی کی رقم',

payment_cash: 'نقد ادائیگی',
payment_span: 'اسپین ادائیگی',
payment_bank: 'بینک ادائیگی',

return_invoice: 'واپس کی گئی انوائس',
return_amount: 'واپس کی گئی رقم',
return: 'واپس کریں',

system_modules: 'سسٹم ماڈیولز',
customers: 'گاہک',
quotations: 'کوٹیشنز',
accounting: 'اکاؤنٹنگ',
envintory: 'انوینٹری',
reports: 'رپورٹس',
settings: 'سیٹنگز',
logout: 'لاگ آؤٹ',

invoice_notes: 'انوائس نوٹس',
add_customer: 'شامل کریں',
additional_mobile: 'اضافی نمبر',
client_statement: 'اکاؤنٹ اسٹیٹمنٹ',
mobil_10_digits: 'موبائل نمبر 10 ہندسوں پر مشتمل ہونا چاہیے',

customer_added: 'گاہک کامیابی سے شامل کر دیا گیا',

add_quotation: 'بنائیں',
quotnumber: 'کوٹیشن نمبر',
salesman: 'سیلز مین',
quot_date: 'کوٹیشن کی تاریخ',
quotation_details: 'کوٹیشن کی تفصیل',
sign_quotation: 'کوٹیشن پر دستخط کریں',

delete: 'حذف کریں',

company_client: 'کارپوریٹ گاہک',

can_not_add_empty_row: 'خالی قطار شامل نہیں کی جا سکتی',
please_add_company_info: 'براہِ کرم کمپنی کی معلومات شامل کریں',

quotation_added: 'کوٹیشن کامیابی سے شامل ہو گیا',

can_not_add_row_without_discription: 'تفصیل کے بغیر قطار شامل نہیں کی جا سکتی',
can_not_add_row_with_qtty: 'براہِ کرم مقدار صفر سے زیادہ درج کریں',

date: 'تاریخ',
credit: 'کریڈٹ',
debit: 'ڈیبٹ',

new_quotations: 'نئے کوٹیشنز',
invoiced_quots: 'انوائس شدہ کوٹیشنز',
canceled_quots: 'منسوخ شدہ کوٹیشنز',

quotation_no: 'کوٹیشن نمبر',

printQuot: 'کوٹیشن پرنٹ کریں',
cancel_quto: 'کوٹیشن منسوخ کریں',

quot_time: 'کوٹیشن وقت',
print: 'پرنٹ کریں',

cash_total: 'نقد کل رقم',
span_total: 'اسپین کل رقم',

voutcher_no: 'واؤچر نمبر',
receive_from: 'وصول کنندہ',
receive_by: 'وصول کرنے والا',

cash: 'نقد',
span: 'اسپین',

received_voucher: 'رسید واؤچر',
exchange_voucher: 'تبادلہ واؤچر',

employees: 'ملازمین',

recurring_expensess: 'بار بار آنے والے اخراجات',

add_voutchre: 'نیا واؤچر شامل کریں',
voutcher_resone: 'واؤچر کی وجہ',

emp_name: 'ملازم کا نام',
id_number: 'شناختی نمبر',

basic_salary: 'بنیادی تنخواہ',
home_allownance: 'رہائشی الاؤنس',
trans_allownance: 'ٹرانسپورٹ الاؤنس',
food_allown: 'کھانے کا الاؤنس',
other_allown: 'دیگر الاؤنس',

goze_perc: 'جی او زی ای',
percentate: 'فیصد',

update: 'اپڈیٹ کریں',
add_employee: 'نیا ملازم شامل کریں',
add_expenses: 'اخراجات شامل کریں',
expense_type: 'اخراجات کی قسم',

yearly: 'سالانہ',
midterm: 'نصف سالہ',
quarterly: 'سہ ماہی',
monthly: 'ماہانہ',
daily: 'یومیہ',

expense_total: 'کل اخراجات',
expense_period: 'اخراجات کی مدت',

calculation_will_be_done_automatic: 'حساب خودکار طور پر کیا جائے گا',

office_rent: 'دفتر کا کرایہ',

add_maint_request: 'جاب آرڈر شامل کریں',

cardid: 'کارڈ نمبر',

received: 'موصول ہوا',
delivered: 'ڈیلیور کیا گیا',

spare_partes: 'اسپیئر پارٹس',
spare_parts: 'اسپیئر پارٹس',
request_spare_parts: 'اسپیئر پارٹس کی درخواست',
request_spare_parts_items: 'اسپیئر پارٹس آئٹمز کی درخواست',
spare_parts_requests: 'اسپیئر پارٹس کی درخواستیں',
purchase_requests: 'خریداری کی درخواستیں',
done: 'مکمل',
not_done: 'نامکمل',
decline: 'مسترد',
confirm_decline_spare_request: 'کیا آپ واقعی اس اسپیئر پارٹس درخواست کو مسترد کرنا چاہتے ہیں؟',
confirm_approve_spare_request: 'کیا آپ واقعی اس اسپیئر پارٹس درخواست کو منظور کرنا چاہتے ہیں؟',
confirm_create_purchase_bill: 'کیا آپ واقعی خریداری بل بنانا / اس درخواست کو آرڈر شدہ کرنا چاہتے ہیں؟',

main_info: 'بنیادی معلومات',

received_date: 'موصول ہونے کی تاریخ',
delivery_date: 'ڈیلیوری کی تاریخ',

customer_info: 'گاہک کی معلومات',
company_info: 'کمپنی کی معلومات',
car_info: 'گاڑی کی معلومات',

received_status: 'موصولی حیثیت',

work_description: 'کام کی تفصیل',
worker: 'کاریگر',
work_price: 'کام کی قیمت',

advanced_payment: 'پیشگی ادائیگی',

attachement: 'اٹیچمنٹ',
choose_file: 'فائل منتخب کریں',

save: 'محفوظ کریں',

additional_information: 'اضافی معلومات',

work_description_required: 'کام کی تفصیل ضروری ہے',

added_sucess: 'کامیابی سے شامل کر دیا گیا',

add_user: 'نیا صارف شامل کریں',
update_user: 'صارف اپڈیٹ کریں',

users: 'صارفین',
user_name: 'پورا نام',
login_name: 'یوزر نیم',

permission: 'اجازتیں',

last_login: 'آخری لاگ ان',

save_login_info: 'لاگ ان معلومات محفوظ کریں',

password: 'پاس ورڈ',

export_excel: 'ایکسل میں ایکسپورٹ کریں',

add_purcahse: 'نئی خریداری شامل کریں',

vendor: 'سپلائر',

vendors: 'سپلائرز',

purchase: 'خریداری',

purchase_order: 'خریداری آرڈر',

purchase_return: 'خریداری واپسی',

purchase_report: 'خریداری رپورٹ',

inventory: 'انوینٹری',

item_name: 'آئٹم کا نام',

sales_invoices: 'سیلز انوائسز',

sales: 'سیلز',
vat_required_return: 'وی اے ٹی درکار (ریٹرن)',
vat_report: 'وی اے ٹی رپورٹ',
dealy_report: 'روزانہ رپورٹ',
card_report: 'کارڈ رپورٹ',
sales_report: 'سیلز رپورٹ',
return_report: 'ریٹرن رپورٹ',

percentage: 'فیصد',
income: 'آمدنی',
expenses: 'اخراجات',
expense: 'خرچ',
period_expenses: 'مدتی اخراجات',

closed_by: 'بند کرنے والا',
return_by: 'واپس کرنے والا',

shortcust_name: 'مختصر نام',
vat_number: 'وی اے ٹی نمبر',

system_settings: 'سسٹم سیٹنگز',
welcometo: 'خوش آمدید',

view_invoice: 'انوائس دیکھیں',

added_date: 'شامل کرنے کی تاریخ',
added_time: 'شامل کرنے کا وقت',

photo_gallary: 'تصویری گیلری',
print_card: 'کارڈ پرنٹ کریں',

car_description: 'گاڑی کی تفصیل',

invoice_samary: 'انوائس خلاصہ',

others: 'دیگر',

view_card: 'کارڈ دیکھیں',
card_closed: 'کارڈ بند ہو گیا',

please_check_data: 'براہِ کرم ڈیٹا چیک کریں',

cant_close_card_when_it_not_fully_paid: 'براہِ کرم پہلے تمام بقایا ادائیگی مکمل کریں',

card_saved: 'کارڈ محفوظ ہو گیا',

customerid: 'گاہک آئی ڈی',

purchase_invoice: 'خریداری کے بل',

billno: 'بل نمبر',

vendor_name: 'سپلائر کا نام',
vendor_mobile: 'سپلائر رابطہ نمبر',
vendor_vatids: 'سپلائر وی اے ٹی نمبر',
vendor_address: 'سپلائر کا پتہ',

type: 'قسم',
bill_type: 'بل کی قسم',

bill_detates: 'بل کی تفصیل',

item_unit: 'آئٹم یونٹ',
pace: 'شرح',

view_purchase_bill: 'خریداری بل دیکھیں',

received_amount: 'موصول شدہ رقم',

close_card: 'کارڈ بند کریں',

chose_file: 'فائل منتخب کریں',
upload: 'اپلوڈ کریں',

full_name: 'پورا نام',

total_amount: 'کل رقم',

buy_goods: 'سامان خریدیں',

sallary: 'تنخواہ',

buy_devices: 'آلات خریدیں',

pay_for_bills: 'بل ادا کریں',

added_successfuly: 'کامیابی سے شامل کر دیا گیا',

nationality: 'قومیت',

percent: 'فیصد',

group_name: 'گروپ کا نام',

permissions: 'اجازتیں',

administratior: 'ایڈمنسٹریٹر',
full_permissions: 'مکمل اجازتیں',

accountant: 'اکاؤنٹنٹ',
accountatn_permissions: 'سیٹنگز کے بغیر مکمل اجازتیں',

cashier: 'کیشیئر',
cashier_permissions: 'انوائس سسٹم اور کارڈ بنانے کی اجازت',

choose_employee: 'ملازم منتخب کریں',

projectname: 'پراجیکٹ کا نام',

inprogress: 'جاری',

closed: 'بند',

not_invoiced: 'بل جاری نہیں ہوا',

vendorid: 'سپلائر آئی ڈی',

paid_in_advanced: 'پیشگی ادائیگی',
paid_in_advanced_amount: 'رقم',

installment_number: 'قسط نمبر',
installment_amount: 'قسط کی رقم',

mor_than_zero: 'براہِ کرم صفر سے زیادہ نمبر درج کریں',

emp_reward: 'انعام دیا گیا',
reward_amount: 'انعام کی رقم',
reward_resone: 'انعام کی وجہ',

emp_deducts: 'کٹوتیاں',
deducts_amount: 'کٹوتی کی رقم',
deducts_resone: 'کٹوتی کی وجہ',
penalty_amount: 'جرمانے کی رقم',
penalty_reason: 'جرمانے کی وجہ',
penalty_reason_required: 'جرمانے کی وجہ لازمی ہے',

canceled: 'منسوخ',
notpaid: 'غیر ادا شدہ',

workstartdate: 'کام شروع ہونے کی تاریخ',

fix_salary: 'تنخواہ مقررہ',

card_expenses: 'انوینٹری سے مرمتی اخراجات',
invoice_expenses: 'انوائس اخراجات',

expenses_summary: 'اخراجات کا خلاصہ',

general_expenses: 'عمومی اخراجات',

cards_expenses: 'مینٹیننس',

invoices_expenses: 'انوائسز',

salaries: 'تنخواہیں',

add_general_expense: 'اخراجات شامل کریں',

periodically: 'وقفے وقفے سے',

payit: 'ابھی ادا کریں',

pay_expenses: 'اخراجات ادا کریں',

payment_period: 'ادائیگی کی مدت',

expense_amount: 'رقم',

othermethod: 'دیگر طریقے',

invoices_total: 'انوائس کل رقم',
invoices_remain: 'انوائس کی بقایا رقم',
other_expenses: 'دیگر اخراجات',
exp_total: 'کل اخراجات',
exp_vat: 'اخراجات پر وی اے ٹی',

employees_and_users: 'ملازمین',

building_no: 'عمارت نمبر',
street_name: 'سڑک کا نام',
branch_number: 'برانچ نمبر',
district: 'علاقہ',
zipcode: 'پوسٹل کوڈ',
city: 'شہر',
address: 'پتہ',

update_customer: 'گاہک اپڈیٹ کریں',
customer_updated: 'گاہک کامیابی سے اپڈیٹ ہو گیا',

update_all: 'سب اپڈیٹ کریں',
update_all_notes: 'سب کو اپڈیٹ کریں: نئی معلومات تمام انوائسز یا رسیدوں پر لاگو ہوں گی',

curency: 'ریال سعودی',
pos: 'پوائنٹ آف سیل',

cancel: 'منسوخ کریں',

total_after_discount: 'ڈسکاؤنٹ کے بعد کل رقم',

multi_payment: 'متعدد ادائیگی طریقے',

paid_amount: 'ادا شدہ رقم',

category_name: 'کیٹیگری',
category_name_ar: 'عربی نام',
category_name_en: 'انگریزی نام',

category_type: 'کیٹیگری کی قسم',
category_parent: 'اصل کیٹیگری',
subcat_count: 'ذیلی کیٹیگریاں',

products: 'آئٹمز',

add_category: 'نئی کیٹیگری شامل کریں',

main_cat: 'مرکزی کیٹیگری',
sub_cat: 'ذیلی کیٹیگری',

income_report: 'آمدنی رپورٹ',
incomes: 'آمدنیاں',

amountprice: 'رقم',

itotals_per_paymethod: 'ادائیگی طریقہ کے مطابق آمدنی کا مجموعہ',
ototals_per_paymethod: 'ادائیگی طریقہ کے مطابق اخراجات کا مجموعہ',

account_statement: 'اکاؤنٹ اسٹیٹمنٹ',

balance: 'بیلنس',

accounts: 'اکاؤنٹس',

account_balance_report: 'بیلنس رپورٹ',

openingbalance: 'ابتدائی بیلنس',

transaction: 'لین دین کا بیلنس',

account: 'اکاؤنٹ',

vlaue: 'قدر',

chart_of_account: 'چارٹ آف اکاؤنٹس',

definition: 'تعریفات',

paytypes: 'ادائیگی کے طریقے',

car_report: 'گاڑی رپورٹ',

amounttotal: 'کل رقم',

namear: 'عربی نام',
nameen: 'انگریزی نام',

classid: 'اکاؤنٹ نمبر',

add_pay_type: 'ادائیگی کا طریقہ شامل کریں',

statment: 'اسٹیٹمنٹ',

class_name: 'اکاؤنٹ کا نام',

fixed_assets: 'مستقل اثاثے',

late: 'تاخیر',

price: 'قیمت',

invoice_total: 'انوائس کل رقم',
vat_total: 'وی اے ٹی کل',

add_vendor: 'نیا سپلائر شامل کریں',
update_vendor: 'سپلائر اپڈیٹ کریں',

vendor_updated_successufly: 'سپلائر کامیابی سے شامل / اپڈیٹ ہو گیا',

vendor_name_required: 'سپلائر کا نام ضروری ہے',
vendor_mobile_required: 'سپلائر کا موبائل نمبر ضروری ہے',

finance_jvs: 'جرنل واؤچر',

jvnom: 'جے وی نمبر',

notes: 'نوٹس',

addJV: 'نیا جرنل واؤچر شامل کریں',

bnl_report: 'منافع و نقصان رپورٹ',

balance_report: 'بیلنس رپورٹ',

gozi_report: 'گوزی رپورٹ',

sales_crm: 'سیلز',

exp_management: 'انتظامی اخراجات',

maintenance_cards: 'مینٹیننس کارڈز',

customer_info_required: 'گاہک کا نام اور موبائل ضروری ہے',

delivery_date_required: 'ڈیلیوری کی تاریخ ضروری ہے',

car_info_required: 'گاڑی کی معلومات ضروری ہیں',

please_choose_worker: 'براہِ کرم کاریگر منتخب کریں',

job_price_required: 'کام کی قیمت ضروری ہے',

customer_addedd: 'گاہک کامیابی سے شامل ہو گیا',

new: 'نیا',

view_employee: 'ملازم دیکھیں',

add_new_account: 'نیا اکاؤنٹ شامل کریں',

account_name_ar: 'عربی نام',
account_name_en: 'انگریزی نام',

mainaccount: 'مرکزی اکاؤنٹ',

accoutn_option: 'اکاؤنٹ اختیارات',

update_acount: 'اکاؤنٹ اپڈیٹ کریں',

acount_name: 'اکاؤنٹ کا نام',

account_type: 'اکاؤنٹ کی قسم',

default_type: 'ڈیفالٹ قسم',

account_integrated: 'انٹیگریٹڈ کے ساتھ',

integrated_with_expenses: 'اخراجات کے ساتھ مربوط',

account_name: 'اکاؤنٹ کا نام',

expeneses_type: 'اخراجات کی قسم',

projects: 'پراجیکٹس',

add_project: 'نیا پراجیکٹ شامل کریں',
additional_method: 'اضافی ڈسکاؤنٹ',
adding_date: 'شامل کرنے کی تاریخ',
ammount: 'رقم',
method: 'طریقہ',
home: 'ہوم',

payment_requests: 'ادائیگیاں',
requests: 'درخواستیں',

ment_req_cards_new: 'نئے مینٹیننس کارڈز',
ment_req_cards_late: 'تاخیر شدہ مینٹیننس کارڈز',
ment_req_cards_closed: 'بند شدہ مینٹیننس کارڈز',

print_pagexport_pdfe: 'پی ڈی ایف ایکسپورٹ کریں',
print_page: 'صفحہ پرنٹ کریں',

sent_requests: 'بھیجی گئی درخواستیں',

item_cost: 'آئٹم لاگت',

username: 'یوزر نیم',
welcome: 'خوش آمدید',

add_product: 'نیا پروڈکٹ شامل کریں',

orders: 'آرڈرز',

booktime: 'بکنگ وقت',

maint_start_date: 'مرمت شروع ہونے کی تاریخ',
maint_end_date: 'مرمت مکمل ہونے کی تاریخ',
policy_number: 'انشورنس پالیسی نمبر',
engine_meter: 'گاڑی کا میٹر ریڈنگ (کلومیٹر)',

next_oil_change: 'اگلی آئل تبدیلی (کلومیٹر کے بعد)',

crt_number: 'کمرشل رجسٹریشن نمبر',

company_name_en: 'کمپنی کا انگریزی نام',

contact_number: 'رابطہ نمبر',

you_cannot_delete_this_item_paid_more_than_total: 'یہ آئٹم حذف نہیں کیا جا سکتا کیونکہ ادا شدہ رقم کل رقم سے زیادہ ہے',

worker_name: 'کاریگر کا نام',

start_date: 'شروع کی تاریخ',
end_date: 'اختتام کی تاریخ',

total_invoices: 'کل انوائسز',

total_remain: 'کل بقایا',

sendWhats: 'واٹس ایپ پر بھیجیں',

salary_report: 'تنخواہ رپورٹ',
percent_report: 'فیصد رپورٹ',

cards_number: 'کارڈز کی تعداد',
catd_totals: 'کارڈز کی کل رقم',

totalPercent: 'کل فیصد',

cards_expsenses: 'کارڈز کے اخراجات',

convert_to_invoice: 'کوٹیشن کو انوائس بنائیں',

chose_month: 'مہینہ منتخب کریں',
year: 'سال',

logo_img: 'لوگو تصویر',

terms_of_use: 'استعمال کی شرائط',
tafweed: 'استعمال کی شرائط',

expense_namear: 'اخراجات کی قسم (عربی نام)',
expense_nameen: 'اخراجات کی قسم (انگریزی نام)',

expenses_type_updated: 'اخراجات کی قسم اپڈیٹ ہو گئی',
add_new_expense_type: 'نئی اخراجات کی قسم شامل کریں',
expenses_type_added: 'اخراجات کی قسم شامل کر دی گئی',

income_expense_report: 'آمدنی و اخراجات رپورٹ',

other: 'دیگر',
expnese: 'اخراجات',

old_balance: 'پرانا بیلنس',

purchase_bill: 'خریداری بل',
purchase_summary: 'خریداری خلاصہ',

print_voucher: 'واؤچر پرنٹ کریں',

sales_vat: 'سیلز وی اے ٹی',
bill_vat: 'خریداری وی اے ٹی',

invoice_export: 'انوائس بنائیں',

add_expense_type: 'اخراجات کی قسم شامل کریں',

name_ar_en_required: 'عربی اور انگریزی نام درکار ہے',

add_direct_invoice: 'براہِ راست انوائس شامل کریں',

car_ifnormation_required: 'گاڑی کی معلومات ضروری ہیں',

save_n_print: 'محفوظ کریں',

print_in_voucher: 'واؤچر پرنٹ کریں',

chose_customer_type: 'گاہک کی قسم منتخب کریں',
chose_invoice_type: 'انوائس کی قسم منتخب کریں',
chose_vat_type: 'وی اے ٹی کی قسم منتخب کریں',
chose_payment_method: 'ادائیگی کا طریقہ منتخب کریں',
chose_saler_name: 'سیلز مین منتخب کریں',

total_without_vat: 'وی اے ٹی کے بغیر کل رقم',

fftotal: 'وی اے ٹی سمیت کل رقم',

changePassword: 'پاس ورڈ تبدیل کریں',
newpassword: 'نیا پاس ورڈ',
oldpassword: 'پرانا پاس ورڈ',

printing_header: 'پرنٹنگ ہیڈر',
invoice_body: 'انوائس باڈی',
voucher_body: 'واؤچر باڈی',
card_body: 'مینٹیننس کارڈ باڈی',
printing_footer: 'پرنٹنگ فوٹر',

car_status_receive: 'گاڑی وصولی کی حالت',

add_attachement: 'اٹیچمنٹ شامل کریں',

government_clinet: 'سرکاری ادارہ',

view_page: 'صفحہ پیش منظر',

return_invoices: 'ریٹرن انوائسز',

vat_summary: 'وی اے ٹی خلاصہ',

add_edit_product: 'پروڈکٹ شامل / ترمیم کریں',

current_qtty: 'موجودہ مقدار',

price_without_vat: 'وی اے ٹی کے بغیر قیمت',
price_inc_vat: 'وی اے ٹی سمیت قیمت',

default_cost: 'ڈیفالٹ لاگت',

added_value_tax: 'ویلیو ایڈڈ ٹیکس فعال کریں',

product_category: 'پروڈکٹ کیٹیگری',
product_type: 'پروڈکٹ کی قسم',

inventory_item: 'انوینٹری آئٹم',
service_item: 'سروس آئٹم',

this_item_service_item: 'صرف انوینٹری آئٹم کو خریداری بل میں شامل کیا جا سکتا ہے',

day: 'دن',

print_out_voucher: 'واؤچر پرنٹ کریں',
expenses_type_reoprt: 'اخراجات کی قسم کی رپورٹ',

view_quotation: 'کوٹیشن دیکھیں',
view_expenses: 'اخراجات کی انوائس دیکھیں',

customer_company_info_required: 'کمپنی کا نام اور پتہ ضروری ہیں',

for_more_information_or_support_firstline: 'مزید معلومات یا معاونت کے لیے ہم سے رابطہ کریں',
for_more_information_or_support_secondline: '0595907777',

whatsapp: 'واٹس ایپ',

add_invoice_notes: 'انوائس میں نوٹس شامل کریں (وارنٹی، شرائط وغیرہ)',

new_customer: 'نیا گاہک',

entity_name: 'ادارے کا نام',
branch_name: 'برانچ کا نام',

request_number: 'درخواست نمبر',
order_number: 'آرڈر نمبر',

po_number: 'درخواست نمبر',
po_date: 'درخواست کی تاریخ',

add_car: 'نئی گاڑی شامل کریں',

footer_extra: 'فوٹر میں اضافہ',

view_quot_pdf: 'ڈاؤن لوڈ کریں',

bid_number: 'بولی نمبر',

expenses_invoices: 'اخراجات کی انوائس',

chose_car: 'گاڑی منتخب کریں',

total_b_d: 'ڈسکاؤنٹ سے پہلے کل رقم',

total_discount: 'ڈسکاؤنٹ',

cars_list: 'گاڑیوں کی فہرست',

out_payments: 'آؤٹ واؤچر',
in_payments: 'ان واؤچر',

changeNote: 'نوٹ تبدیل کریں',

are_you_sure: 'کیا آپ کو یقین ہے؟',

add_invocie: 'انوائس شامل کریں',

add_new_card: 'نیا جاب آرڈر شامل کریں',

cars_status: 'گاڑیوں کی حالت',

reset: 'ری سیٹ کریں',
undo: 'واپس کریں',

chose_customer: 'گاہک منتخب کریں',
chose_company: 'کمپنی منتخب کریں',
chose_entity: 'ادارہ منتخب کریں',

company_name_required: 'کمپنی کا نام ضروری ہے',
customer_name_required: 'گاہک کا نام ضروری ہے',
company_address_required: 'کمپنی کا پتہ ضروری ہے',
entity_name_required: 'ادارے کا نام ضروری ہے',

car_information_must_be_complated: 'گاڑی نمبر {{plate_number}} کی معلومات مکمل کرنا ضروری ہے',

you_must_add_one_car_atleast: 'کم از کم ایک گاڑی شامل کرنا ضروری ہے',

you_must_add_atleast_one_work_item: 'کم از کم ایک کام کا آئٹم شامل کرنا ضروری ہے',

plase_select_car_scratch: 'خالی تصویر شامل نہیں کی جا سکتی',

chose_car_before_continue: 'جاری رکھنے سے پہلے گاڑی منتخب کریں',

approve_card: 'کارڈ منظور کریں',

isbilled: 'بل ہو چکا ہے',

complete: 'مکمل',

add_new_work_expenses: 'نیا کام / اسپیئر پارٹ شامل کریں',

row_type: 'قطار کی قسم',

agree: 'متفق',

details: 'تفصیلات',

time: 'وقت',

payment_type: 'ادائیگی کی قسم',

amount: 'رقم',

debet: 'ڈیبٹ',

daily_summary_for_date: 'تاریخ کے لیے روزانہ خلاصہ',

today_balance: 'آج کا بیلنس',

previews_balance: 'پچھلا بیلنس',

total_balance: 'کل بیلنس',

purchase_and_expenses: 'خریداری و اخراجات',

credit_note: 'کریڈٹ نوٹس',

period_balance: 'مدتی بیلنس',

add_vendor_voucher: 'ایکسچینج واؤچر شامل کریں',

salary_paid: 'تنخواہ کی ادائیگی',

client_statment: 'گاہک اسٹیٹمنٹ',

file_size: 'فائل کا سائز',
file_name: 'فائل کا نام',

download: 'ڈاؤن لوڈ',

cancel_order: 'آرڈر منسوخ کریں',

add_order: 'نیا آرڈر شامل کریں',
view_order: 'آرڈر دیکھیں',

orderid: 'آرڈر آئی ڈی',
order_date: 'آرڈر کی تاریخ',
order_time: 'آرڈر کا وقت',

order_details: 'آرڈر کی تفصیل',
order_items: 'آرڈر آئٹمز',

cancel_qtty: 'منسوخ مقدار',
cancel_reson: 'منسوخی کی وجہ',

full_cancel_reson: 'مکمل منسوخی کی وجہ',

full_cancel: 'مکمل منسوخ',

partial_cancel: 'جزوی منسوخ',

custody: 'امانت',

return_custody: 'امانت سے ادا شدہ',

remain_custody: 'امانت میں باقی',

add_custody: 'امانت شامل کریں',

width: 'چوڑائی',
thickness: 'موٹائی',

limited: 'محدود',

customer_sign: 'دستخط',

back: 'واپس',

terms_and_conditions: 'شرائط و ضوابط',

work_hours: 'کام کے اوقات',

vendor_payments: 'سپلائر کی ادائیگیاں',

terms: 'شرائط',

pay_from_custdy: 'امانت سے ادائیگی',
pay_from_cash: 'نقد سے ادائیگی',

emp_statment: 'ملازم اسٹیٹمنٹ',

deduct_from_salary: 'تنخواہ سے کٹوتی',

pay_advanced: 'پیشگی ادائیگی',
add_reward: 'انعام شامل کریں',

post_salary: 'تنخواہ پوسٹ کریں',
indemnity: 'معاوضہ',
posted_salary: 'پوسٹ کی گئی تنخواہ',

card_percentage: 'کارڈ فیصد',
invoice_percentage: 'انوائس فیصد',

remain_salary: 'باقی تنخواہ',
lated_salaries: 'باقی تنخواہیں',
salary_total: 'کل تنخواہ',

custdy: 'امانت',

mentanace_card: 'مینٹیننس کارڈز',

service: 'سروسز',

deduct: 'کٹوتی',

paid_in_advanced_total: 'کل پیشگی ادائیگی',

number_of_parts: 'پارٹس کی تعداد',
part_amount: 'پارٹ کی رقم',

returned: 'واپس کیا گیا',

deduct_resone: 'کٹوتی کی وجہ',

minute_late: 'دیر کے منٹس',

deduct_type: 'کٹوتی کی قسم',

monthly_late: 'ماہانہ تاخیر',

deduct_amount: 'کٹوتی کی رقم',

monthly_deduct: 'ماہانہ کٹوتی',

fix_it: 'درست کریں',

today_date: 'آج کی تاریخ',

search_by_name: 'نام سے تلاش کریں',

daily_report: 'روزانہ رپورٹ',

max_items_sales: 'سب سے زیادہ فروخت',
less_items_sates: 'سب سے کم فروخت',

zero_items: 'زیرو آئٹمز',

sales_qtty: 'فروخت کی مقدار',

total_income: 'کل آمدنی',

current_qty: 'موجودہ مقدار',

remainpso: 'باقی',

open_shift: 'شفٹ شروع',

_total_1_ryals: '1 ریال',
_total_5_ryals: '5 ریال',
_total_10_ryals: '10 ریال',
_total_20_ryals: '20 ریال',
_total_50_ryals: '50 ریال',
_total_100_ryals: '100 ریال',
_total_500_ryals: '500 ریال',

opening_balance: 'ابتدائی بیلنس',

open_new_shift: 'نئی شفٹ کھولیں',

calendar: 'کیلنڈر',

add_purchase: 'خریداری شامل کریں',

clode_shift: 'شفٹ بند کریں',

total_payment_to_vendor: 'سپلائر کی باقی ادائیگی ہے: ',
total_payment_to_Client: 'گاہک کی باقی ادائیگی ہے: ',

client_statement_pos: 'گاہک اسٹیٹمنٹ',

client_appointment: 'گاہک کیلنڈر',

add_client_voucher: 'گاہک کی ادائیگی شامل کریں',

invoice_summary: 'انوائس خلاصہ',

total_after_discountt: 'ڈسکاؤنٹ کے بعد قیمت',

cashair: 'کیشیئر',

managment: 'انتظامیہ',

smiller_products: 'ملتے جلتے پروڈکٹس',

emp_custody: 'ملازم کی امانت',

menu: 'مینو',

book_tables: 'ٹیبل بک کریں',

add_your_cash: 'اپنی شفٹ کی رقم شامل کریں',

mobile_info_required: 'گاہک کا موبائل ضروری ہے اور 4 ہندسوں سے زیادہ ہونا چاہیے',

mobile_info_required_fullmobile: 'گاہک کا موبائل ضروری ہے اور 05 سے شروع ہو اور 5 ہندسوں سے زیادہ ہو',

name_info_required: 'گاہک کا نام ضروری ہے اور 5 حروف سے زیادہ ہونا چاہیے',

view_customer: 'گاہک دیکھیں',

add_fincance_request: 'مالی درخواست شامل کریں',

cars: 'گاڑیاں',

add_notes: 'نوٹس شامل کریں',

finance_report: 'مالی رپورٹ',

unpaid_job_orders: 'غیر انوائس شدہ',

report: 'رپورٹ',

financial_request: 'مالی درخواستیں',

tasks: 'ٹاسکس',

add_task: 'نیا ٹاسک شامل کریں',

task_description: 'ٹاسک کی تفصیل',

dead_line: 'آخری تاریخ',

task_to: 'ٹاسک صارف کو',

task_description_required: 'ٹاسک کی تفصیل ضروری ہے',

task_start_end_date_required: 'ٹاسک کی شروعات اور آخری تاریخ ضروری ہے',

start_time_required: 'کیلنڈر شروع اور آخری وقت ضروری ہے',

last_update_by: 'آخری اپڈیٹ کرنے والا',

last_update_date: 'آخری اپڈیٹ کی تاریخ',

closed_date: 'بند ہونے کی تاریخ',

add_warantly: 'وارنٹی کام',

plate_number_required: 'نمبر پلیٹ ضروری ہے',

add_booking: 'بکنگ',

start_time: 'شروع وقت',

deadline_time: 'آخری وقت',

book_calendar: 'کیلنڈر',

tasks_status: 'ٹاسکس',

warantly_status: 'وارنٹی',

calendar_status: 'کیلنڈر',

customer_status: 'گاہک کی حالت',

ment_description: 'مینٹیننس کی تفصیل',

add_new_spare_part: 'نیا اسپیئر پارٹ شامل کریں',

spare_part_item_code: 'اسپیئر پارٹ آئٹم کوڈ',

add_spare_part: 'اسپیئر پارٹ شامل کریں',

work_type: 'کام کی قسم',

carsnumber: 'گاڑیوں کی تعداد',
add_new_status: 'نیا اسٹیٹس شامل کریں',

vin_numebr: 'VIN',
vin_number: 'VIN',

brand_name: 'گاڑی کا برانڈ',

ready_to_deliver: 'ڈیلیوری کے لیے تیار',

cancel_card: 'منسوخ کریں',

calendar_table: 'کیلنڈر ٹیبل',

choose_custoemr: 'گاہک منتخب کریں',

estimated_price: 'اندازاً قیمت',

work_name: 'کام کا نام',

booking_procedure: 'بکنگ طریقہ کار',

change_booking_date: 'بکنگ تاریخ تبدیل کریں',

edit_calendar: 'کیلنڈر ترمیم کریں',

expire_date: 'ختم ہونے کی تاریخ',

note_date: 'نوٹ کی تاریخ',

added_by: 'شامل کرنے والا',

task_type: 'ٹاسک کی قسم',

training: 'ٹریننگ',

job_order: 'جاب آرڈر',

last_update: 'آخری اپڈیٹ',

last_action: 'آخری کارروائی',

next_action: 'اگلی کارروائی',

next_action_date: 'کارروائی کی تاریخ',

agent: 'ایجنٹ',

view_crm: 'CRM دیکھیں',

generate_license: 'لائسنس بنائیں',

note_text: 'نوٹ متن',

note_type: 'نوٹ کی قسم',

task_response: 'جواب',

license_url: 'لائسنس لنک',

copies: 'لائسنس کی تعداد',

include_computers: 'کمپیوٹر شامل کریں',

yes_19: 'ہاں، 19 انچ شامل کریں',

yes_24: 'ہاں، 24 انچ شامل کریں',

no_devices: 'نہیں',

last_action_date: 'آخری کارروائی کی تاریخ',

whats_type: 'واٹس ایپ پیغام کی قسم',

whats_url_multi: 'ڈاکیومنٹ، تصویر، ویڈیو لنک',

update_task: 'ٹاسک اپڈیٹ کریں',

industrial: 'صنعتی',

support_ticket: 'سپورٹ',

add_support: 'سپورٹ شامل کریں',

send_date: 'بھیجنے کی تاریخ',

message_type: 'پیغام کی قسم',

message_text: 'پیغام کا متن',

customer_number: 'گاہک کا نمبر',

sending_number: 'بھیجنے والا نمبر',

media_link: 'میڈیا لنک',

send_whatsapp: 'واٹس ایپ بھیجیں',

send_to: 'بھیجیں',

sent_type: 'بھیجنے کی قسم',

number_list: 'نمبروں کی فہرست',

number_list_notes: 'نمبروں کو کاما سے الگ کریں',

image_url: 'تصویر کا لنک',

document_url: 'ڈاکیومنٹ لنک',

vedio_url: 'ویڈیو لنک',

message_title: 'موضوع',

client_type: 'گاہک کی قسم',

cannot_delete_this_customer_invoices_found: 'اس گاہک کی انوائس موجود ہیں، حذف نہیں کیا جا سکتا',

cannot_delete_this_customer_cards_found: 'اس گاہک کے جاب کارڈ موجود ہیں، حذف نہیں کیا جا سکتا',

custoemr_delete_done: 'گاہک کامیابی سے حذف ہوگیا',

cannot_delete_this_vendor_invoices_found: 'اس سپلائر کی انوائس موجود ہیں، حذف نہیں کیا جا سکتا',

cannot_delete_this_vendor_payment_found: 'اس سپلائر کی ادائیگیاں موجود ہیں، حذف نہیں کیا جا سکتا',

vendor_delete_done: 'سپلائر کامیابی سے حذف ہوگیا',

employee_deleted: 'ملازم حذف ہوگیا',

advanced_payment_deleted: 'ایڈوانس ادائیگی حذف ہوگئی',

employee_name: 'ملازم کا نام',

number_of_tasks: 'ٹاسکس کی تعداد',

closed_tasks: 'بند',

canceled_tasks: 'منسوخ',

opened_tasks: 'کھلے',

add_work_order: 'ورک آرڈر شامل کریں',

owner_name: 'گاڑی کے مالک کا نام',

companies: 'کمپنیاں',

exeute_date: 'عمل درآمد کی تاریخ',

task_priority: 'ٹاسک کی ترجیح',

day_name: 'دن کا نام',

industry: 'انڈسٹری',

support: 'سپورٹ',

project_type: 'پروجیکٹ کی قسم',

project_title: 'پروجیکٹ کا عنوان',

project_owner: 'پروجیکٹ اونر',

project_start: 'پروجیکٹ شروع',

project_deadline: 'پروجیکٹ آخری تاریخ',

project_close_date: 'پروجیکٹ بند',

project_employees: 'پروجیکٹ ملازمین',

employee: 'ملازمین',

task: 'ٹاسک',

task_title: 'ٹاسک عنوان',

checklist: 'چیک لسٹ',

superVisor: 'نگران',

super_visor_required: 'نگران ضروری ہے',

mobile_required: 'موبائل نمبر ضروری ہے',

new_sales: 'نئی فروخت',

return_sales: 'واپس کی گئی فروخت',

card_type: 'کارڈ کی قسم',

add_store: 'اسٹور شامل کریں',

store_name_ar: 'اسٹور نام (عربی)',

store_name_en: 'اسٹور نام (انگریزی)',

account_number: 'اکاؤنٹ نمبر',
trans_from: 'منتقل کریں سے',
trans_to: 'منتقل کریں کو',
trans_type: 'منتقلی کی قسم',
received_by: 'موصول کرنے والا',
add_transfer: 'منتقلی شامل کریں',
add_sinventory: 'انونٹری شامل کریں',
// inventory_item: 'انونٹری شامل کریں',
start_qtty: 'ابتدائی مقدار',
cost_price: 'لاگت کی قیمت',
add_contract: 'معاہدہ شامل کریں',
contract_id: 'معاہدہ نمبر',
last_maint_date: 'آخری دیکھ بھال کی تاریخ',
last_maint_by: 'آخری دیکھ بھال کرنے والا',
cars_number: 'گاڑیوں کی تعداد',
contract_date: 'معاہدہ تاریخ',
contract_expire_date: 'معاہدہ کی میعاد ختم',
contract_start_date: 'معاہدہ شروع ہونے کی تاریخ',
meter_car: 'کار میٹر',
supports: 'سپورٹس',
contracts: 'معاہدے',
job_cards: 'جاب کارڈ',
expected_income: 'متوقع آمدنی',
title: 'عنوان',
old_invoice: 'پرانا انوائس',
unitId: 'یونٹ نمبر',
main_unit_ar: 'مرکزی یونٹ نام (عربی)',
main_unit_en: 'مرکزی یونٹ نام (انگریزی)',
add_unit: 'یونٹ شامل کریں',
update_units: 'یونٹ اپڈیٹ کریں',
unit_type: 'یونٹ کی قسم',
main_unit: 'مرکزی یونٹ',
standard_minutes: 'معیاری وقت (منٹ)',
customer_portal: 'کسٹمر پورٹل',
technician_portal: 'ٹیکنیشن پورٹل',
coming_soon: 'جلد آ رہا ہے۔',
login_mobile_number: 'موبائل نمبر',
send_verification_code: 'تصدیقی کوڈ بھیجیں',
verification_code: 'تصدیقی کوڈ',
verify_code: 'تصدیق کریں',
resend_code: 'کوڈ دوبارہ بھیجیں',
my_profile: 'میری پروفائل',
email: 'ای میل',
my_mobile_numbers: 'موبائل نمبرز',
main: 'مرکزی',
make_main: 'مرکزی بنائیں',
add_new_mobile: 'نیا موبائل نمبر شامل کریں',
login: 'لاگ ان',
no_jobs_assigned: 'اس وقت آپ کو کوئی کام تفویض نہیں کیا گیا۔',
my_records: 'میرے ریکارڈز',
visit_request: 'وزٹ کی درخواست',
no_records: 'کوئی ریکارڈ نہیں۔',
download_pdf: 'پی ڈی ایف ڈاؤن لوڈ کریں',
accept_request: 'درخواست قبول کریں',
remaining: 'باقی',
request_date: 'تاریخ',
request_time: 'وقت',
request_note: 'نوٹس',
submit_request: 'درخواست بھیجیں',
my_requests: 'میری درخواستیں',
service_requests_queue: 'کسٹمر درخواستوں کی فہرست',
confirm: 'تصدیق کریں',
reject: 'مسترد کریں',
pending: 'زیر التواء',
confirmed: 'تصدیق شدہ',
rejected: 'مسترد شدہ',
all: 'تمام',
excellent: 'بہترین',
good: 'اچھا',
bad: 'خراب',
rating: 'ریٹنگ',
start: 'شروع کریں',
pause: 'موقوف کریں',
finish: 'مکمل کریں',
resume: 'دوبارہ شروع کریں',
technician_ratings_dashboard: 'ٹیکنیشن ریٹنگ ڈیش بورڈ',
pause_reason: 'موقوف کرنے کی وجہ',
job_history: 'تاریخ اور گفتگو',
write_a_message: 'پیغام لکھیں...',
loading: 'لوڈ ہو رہا ہے...',
system: 'سسٹم',
history: 'تاریخ اور گفتگو',
add_photo: 'تصویر شامل کریں',
my_jobs: 'میرے کام',
vendor_code: 'سپلائر کوڈ',
is_finalProduct: 'آئٹم کی قسم',
saleable: 'فروخت کے قابل',
update_procedures: 'طریقہ کار اپڈیٹ کریں',
procedure: 'طریقہ کار',
erocedure_date: 'طریقہ کار کی تاریخ',
client_priority: 'ترجیح',
web_url: 'ویب لنک',
purchase_inv: 'خریداری کی انوائس',
api_token: 'واٹس ایپ API ٹوکن (اس کے لیے کال کریں 0595907777)',
send_attachment: 'اٹیچمنٹ بھیجیں',
PublishMe: 'لائسنس جنریٹ کریں',
client_source: 'کلائنٹ کا ماخذ',
add_offer: 'آفر شامل کریں',
offer_name: 'آفر کا نام',
offer_start: 'آفر شروع',
offer_end: 'آفر ختم',
add_new: 'نیا شامل کریں',
campaign_start: 'مہم شروع',
campaign_start_time: 'مہم شروع ہونے کا وقت',
campaign_title: 'مہم کا عنوان',
what_to_send: 'کیا بھیجنا ہے',
send: 'بھیجیں',
working_time_star: 'کام شروع',
working_time_end: 'کام ختم',
product: 'پروڈکٹ',
last_10_messages: 'آخری 10 پیغامات',
executed_date: 'عمل درآمد کی تاریخ',
support_case: 'سپورٹ کیس',
support_procedure: 'سپورٹ طریقہ کار',
source: 'ماخذ',
service_name: 'سروس کا نام',
available_times: 'دستیاب اوقات',
support_type: 'سپورٹ کی قسم',
department: 'شعبہ',
customer_require: 'گاہک ضروری ہے',
subject_require: 'موضوع ضروری ہے',
start_date_require: 'شروع ہونے کی تاریخ ضروری ہے',
executed_date_require: 'عمل درآمد کی تاریخ ضروری ہے',
deadline_require: 'آخری تاریخ ضروری ہے',
times_require: 'کم از کم 1 دستیاب وقت منتخب کریں',
notes_require: 'نوٹس ضروری ہیں',
alert: 'الرٹ',
error_no_qty: 'یہ آئٹم موجود نہیں یا مقدار نہیں، براہ کرم اسے خریداری کی انوائس کے ذریعے شامل کریں',
mobile_alert_10: 'موبائل نمبر 05 سے شروع ہونا چاہیے اور 10 ہندسوں کا ہونا چاہیے',
all_calr_plate_field_required: 'تمام فیلڈز ضروری ہیں',
car_digit_4: 'گاڑی کی پلیٹ 4 ہندسوں کی ہونی چاہیے',
pay_more_than_price: 'کل انوائس سے زیادہ ادائیگی نہیں کر سکتے',
all_field_require: 'تمام فیلڈز ضروری ہیں',
date_out_of_day: 'آج سے زیادہ تاریخ منتخب نہیں کر سکتے',
date_required: 'تاریخ ضروری ہے',
empty_invoice_error: 'خالی انوائس شامل نہیں کر سکتے',
payment_method_error: 'ادائیگی کا طریقہ منتخب کریں',
custoday_not_equal: 'ملازم کی امانت مکمل ادائیگی نہیں ہوئی',
call: 'کال',
branches: 'برانچز',
taxes: 'ٹیکسز',
stores: 'اسٹورز',
successfuly_job: 'کام مکمل ہوا',
renewal_amount: 'تجدید رقم',
renew: 'تجدید',
years: 'سال',
temporary_expenses: 'عارضی اخراجات',
select_store_before_continue: 'اسٹور منتخب کریں',
please_add_one_item_before_continue: 'جاری رکھنے کے لیے کم از کم 1 آئٹم شامل کریں',
company_name_and_company_address_required: 'کمپنی کا نام اور پتہ ضروری ہے',
carstotal: 'کل گاڑیاں',
item_totals: 'کل آئٹمز',
created_by: 'شامل کرنے والا',
card_supervisor: 'کارڈ ٹیک',
technical: 'تکنیکی',
brand: 'برانڈ',
color: 'رنگ',
vin: 'وی آئی این',
visit_oursite: 'ہماری ویب سائٹ دیکھیں',
from_store: 'اسٹور سے',
to_store: 'اسٹور کو',
available_qtty: 'دستیاب مقدار',
transfer_qtty: 'منتقل کرنے کی مقدار',
costs: 'لاگت',
wins: 'کل منافع',
profit: 'منافع',
unit_namear: 'یونٹ کا عربی نام',
unit_nameen: 'یونٹ کا انگریزی نام',
no_account_en: 'کوئی اکاؤنٹ نہیں',
product_namear: "پروڈکٹ کا عربی نام",
product_nameen: "پروڈکٹ کا انگریزی نام",
is_saleable: 'کیا یہ پروڈکٹ فروخت کے قابل ہے',
card_paid: "ادا شدہ",
card_not_paid: "ادا نہیں ہوا",
card_paid_status: 'ادائیگی کی حالت',
note_text_required: 'نوٹ کا متن ضروری ہے',
sub_accounts: 'ذیلی اکاؤنٹس',
add_sub_account: 'ذیلی اکاؤنٹ شامل کریں',
balance_type: 'بیلنس',
bnl_type: 'منافع اور نقصان',
income_type: 'آمدنی',
other_type: 'دیگر',
analyses_account: 'تجزیات',
main_account: 'مرکزی',
gov_expenses: 'سرکاری اخراجات',
update_journal: 'جرنل اپڈیٹ کریں',
add_new_journal: 'نیا جرنل شامل کریں',
error_date: 'براہ کرم اپنی مالی سال کے اندر تاریخ منتخب کریں',
add_fixed_assets: 'مستقل اثاثے شامل کریں',
udpate_fixed_assets: 'مستقل اثاثے اپڈیٹ کریں',
purchase_date: 'خریداری کی تاریخ',
purchase_price: 'خریداری کی قیمت',
depreciation_rate: 'گھٹاؤ کی شرح',
depreciation_period: 'گھٹاؤ کی مدت',
depreciation_amount: 'گھٹاؤ کی رقم',
current_price: 'موجودہ قیمت',
fixed_assets_namear: 'مستقل اثاثے عربی نام',
fixed_assets_nameen: 'مستقل اثاثے انگریزی نام',
plase_add_assets_ar_name: 'براہ کرم اثاثے کا عربی نام شامل کریں',
plase_add_assets_en_name: 'براہ کرم اثاثے کا انگریزی نام شامل کریں',
please_add_purchase_price: 'براہ کرم خریداری کی قیمت شامل کریں',
please_add_purchase_date: 'براہ کرم خریداری کی تاریخ شامل کریں',
please_add_qtty: 'براہ کرم مقدار شامل کریں',
add_out_voucher: 'واؤچر شامل کریں',
edit_voucher: 'واؤچر اپڈیٹ کریں',
delete_invoice: 'انوائس حذف کریں',
return_selected: 'منتخب شدہ واپس کریں',
delete_selected: 'منتخب شدہ حذف کریں',
final_product: 'فائنل پروڈکٹ',
raw_material: 'خام مال',
assembly_product: 'اسمبلی',
assembly_components: 'اسمبلی اجزاء',
add_material: 'مواد شامل کریں',
select_material: 'مواد منتخب کریں',
assembly_components_required: 'اسمبلی میں کم از کم ایک درست مواد ہونا ضروری ہے۔',
required_assembly_components: 'لازمی مواد',
optional_assembly_components: 'اختیاری مواد',
optional_assembly_components_help: 'اسمبلی کو آرڈر میں شامل کرتے وقت صارف ان مواد کا انتخاب کر سکتا ہے۔',
add_optional_material: 'اختیاری مواد شامل کریں',
choose_optional_materials: 'اختیاری مواد منتخب کریں',
add_assembly_to_order: 'اسمبلی آرڈر میں شامل کریں',
assembly_components_save_failed: 'اسمبلی کا مواد محفوظ نہیں ہو سکا',
factory_item: 'فیکٹری آئٹم',
salesable: 'فروخت کے قابل',
none_salesable: 'فروخت کے قابل نہیں',
unit_name: 'یونٹ کا نام',
sale_price: 'فروخت کی قیمت',
minimum_salse_price: 'کم سے کم قیمت',
maximum_salse_price: 'زیادہ سے زیادہ قیمت',
finger_print_id: 'فنگر پرنٹ آئی ڈی',
employee_name_required: 'ملازم کا نام ضروری ہے',
mobile_number_required: 'موبائل نمبر ضروری ہے',
base_salary_required: 'بنیادی تنخواہ ضروری ہے',
update_add_employee_success: "ملازم کامیابی کے ساتھ شامل / اپڈیٹ ہوا",
select_month: 'ماہ منتخب کریں',
select_year: 'سال منتخب کریں',
custody_amount: 'امانت کی رقم',
attend_late: 'دیر سے حاضری',
left_early: 'جلدی روانہ',
not_attend: 'غیر حاضر',
trial_in_balances: 'ٹریل بیلنس میں',
trial_in_totals: 'کل میں ٹریل',
trial_balance: 'ٹریل بیلنس',
hide_zero_accounts: 'صفر والے اکاؤنٹس چھپائیں',
pnl_report: 'منافع اور نقصان رپورٹ',
this_item_used_you_can_not_delete_it: 'یہ آئٹم استعمال ہو چکا ہے، آپ اسے حذف نہیں کر سکتے',
deleted_successfuly: 'کامیابی کے ساتھ حذف ہوا',
parent_classid: 'والدین کلاس',
parent_class_name: 'والدین کا نام',
coa_report_with_totals: 'COA رپورٹ کل کے ساتھ',
coa_report: 'COA رپورٹ',
inventory_report: 'انوینٹری رپورٹ',
select_store: 'اسٹور منتخب کریں',
add_periodic_maint: 'پیریڈک مینٹیننس شامل کریں',
last_visit: 'آخری وزٹ',
visit_type: 'وزٹ کی قسم',
add_vacation: 'چھٹی شامل کریں',
number_of_days: 'دنوں کی تعداد',
period_maint: 'پیریڈک مینٹیننس',
maint_prog: 'مینٹیننس پروگرام',
maint_contract: 'مینٹیننس معاہدہ',
updatePeriodMaint: 'پیریڈ اپڈیٹ کریں',
add_title: 'عنوان شامل کریں',
title_cond: 'عنوان',
campaign_price: 'مہم کی قیمت',
return_quotation: 'واپس لیں',
FixedAssets: 'مستقل اثاثے',
all_regions: 'تمام شہر',
exact_city: 'مخصوص شہر',
campaign_area: 'مہم کا علاقہ',
vehicle_type: 'گاڑی کی قسم',
campaign_end: 'مہم ختم',
campaign_branches: 'مہم کی شاخیں',
campaign_target: 'مہم کا ہدف',
campaign_cost: 'مہم کی لاگت',
campaign_clients: 'مہم کے صارفین',
campaign_profit: 'مہم کا منافع',
created_date: 'تخلیق کی تاریخ',
all_branches: 'تمام شاخیں',
view_offer: 'آفر دیکھیں',
view_subscriber: 'سبسکرائبر دیکھیں',
customer_afforded: 'صارف برداشت کر سکتا ہے',
car_digi_4: 'گاڑی کے پلیٹ نمبر کے 4 ہندسوں کے ہونا ضروری ہیں',
afforded_customer_name: 'صارف کا نام جو برداشت کر سکتا ہے',
sales_total: 'کل فروخت',
sales_ftotal: 'VAT کے ساتھ کل فروخت',
all_total: 'کل درخواست شدہ',
customer_support: 'صارف کی مدد',
calnder_all_field_required: 'کیلنڈر کے تمام فیلڈز ضروری ہیں',
vacation_reasons: 'چھٹی کی وجہ',
vacation_remains: 'باقی چھٹی',
vacation_start_date_required: 'چھٹی کی شروعات کی تاریخ ضروری ہے',
vacation_reasons_required: 'چھٹی کی وجہ ضروری ہے',
your_vacation_limit_is_overdue: 'آپ کی چھٹی کی حد ختم ہو چکی ہے',
vacations: 'چھٹیاں',
refresh: 'تازہ کریں',
chose_from_list: 'فہرست سے منتخب کریں',
addes_successfuly: 'کامیابی سے شامل کیا گیا',
process_job_list: 'جاری شدہ کام کے احکامات',
closed_job_list: 'بند شدہ کام کے احکامات',
not_invoice_job_list: 'غیر انوائس شدہ کام کے احکامات',
invoiced_job_list: 'انوائس شدہ کام کے احکامات',
current_paid_job_list: 'موجودہ ادا شدہ کام کی فہرست',
cashflow: 'نقدی کا بہاؤ',
choose_mentainance_date: 'مینٹیننس کی تاریخ منتخب کریں',
maintenance_time: 'مینٹیننس کا وقت',
offers_programs: 'آفر پروگرامز',
program_name: 'پروگرام کا نام',
booking_date: 'بکنگ کی تاریخ',
booking_time: 'بکنگ کا وقت',
contract_details: 'معاہدے کی تفصیلات',
work_order: 'کام کا حکم',
print_job_order: 'کام کے حکم کی پرنٹ',
work_total_price: 'کام کا کل قیمت',
other_profit_total: 'دیگر منافع کل',
all_: 'سب',
chose_store: 'گودام منتخب کریں',
cost_center_name_ar: 'کاسٹ سینٹر عربی نام',
cost_center_name_en: 'کاسٹ سینٹر انگریزی نام',
costCenter: 'کاسٹ سینٹر',
addCostCenter: 'کاسٹ سینٹر شامل کریں',
without_cost_center: 'بغیر کاسٹ سینٹر',
account_client_type: 'صارف اکاؤنٹ کی قسم',
main_clients: 'مرکزی اکاؤنٹ',
without_account: 'صارف کا اکاؤنٹ نہیں',
depreciation_account: 'گھٹاؤ اکاؤنٹ',
quarter: 'چہارماہی',
semiannually: 'چھ ماہہ',
annually: 'سالانہ',
delivery_note: 'ڈیلیوری نوٹ',
consumption_rate: 'ڈسکاؤنٹ فیصد',
consumption_fees: 'اخراجات کی فیس',
consumption_value: 'اخراجات کی فیس',
add_check: 'چیک شامل کریں',
checkup_type: 'چیک اپ کی قسم',
checkup_number: 'چیک اپ نمبر',
insurance_company: 'انشورنس کمپنی',
delivered_by: 'کی طرف سے فراہم کیا گیا',
car_received_status: 'گاڑی کی وصولی کی حالت',
maintenance_required: 'مینٹیننس درکار ہے',
direction: 'سمت',
description_required: 'تفصیل ضروری ہے اور خالی نہیں ہو سکتی',
insurance_company_required: 'انشورنس کمپنی شامل کرنا ضروری ہے',
customer_required: 'صارف شامل کرنا ضروری ہے',
car_model_required: 'گاڑی کا ماڈل شامل کریں',
car_brand_required: 'گاڑی کی کمپنی شامل کریں',
car_color_required: 'گاڑی کا رنگ ضروری ہے',
please_add_one_car_received_status: 'کم از کم ایک گاڑی کی حالت شامل کریں',
please_add_one_car_maintenance: 'کم از کم ایک مرمت کی درخواست شامل کریں',
checkup_id: 'گاڑی وصولی کا شناختی نمبر',
owner_mobile_number: 'مالک کا موبائل نمبر',
discountType: 'ڈسکاؤنٹ کی قسم',
report_day: 'دن منتخب کریں',
exit_time: 'اختتامی وقت',
chose_user: 'صارف منتخب کریں',
report_type: 'رپورٹ کی قسم',
printer_type: 'پرنٹر کی قسم',
quotation: 'عرض قیمت',
car_location: 'گاڑی کا مقام',
transportant_info: 'نقل و حمل کی معلومات',
transportant_name: 'نقل و حمل کرنے والا کا نام',
transport_direction: 'آمد کی سمت',
driver_name: 'ڈرائیور کا نام',
driver_mobile: 'ڈرائیور کا موبائل نمبر',
trnasport_type: 'نقل و حمل کی قسم',
store: 'گودام کا نام',
special_return: 'خاص واپسی',
return_total_price: 'واپسی کی کل قیمت',
print_return: 'واپسی پرنٹ کریں',
viewr_pdf: 'PDF ڈاؤن لوڈ کریں',
vendor_category: 'سپلائر کی قسم',
only_vendor: 'صرف سپلائر',
vendor_and_customer: 'صارف اور سپلائر',
nd_start_date: 'شروع کی تاریخ',
nd_end_date: 'اختتامی تاریخ',
nd_branches: 'برانچز',
nd_search: 'تلاش',
nd_finance_module: 'فنانس ماڈیول',
nd_calendar_dashboard: 'کیلنڈر ڈیش بورڈ',
nd_calendar_type: 'کیلنڈر کی قسم',
nd_worker_tasks: 'ورکر ٹاسکس',
nd_delivery_cars: 'گاڑیوں کی ڈیلیوری',
nd_no_records: 'منتخب مدت میں کوئی ریکارڈ نہیں ملا۔',
nd_job_cards: 'جاب کارڈز',
nd_work_orders: 'ورک آرڈرز',
nd_job_orders: 'جاب آرڈرز',
nd_income_by: 'آمدنی بذریعہ',
nd_intervals: 'وقفے',
nd_expense_breakdown: 'اخراجات کی تفصیل',
nd_total_expenses: 'کل اخراجات',
nd_sales_items: 'سیلز آئٹمز',
nd_extra_profit: 'اضافی منافع',
nd_total_profit: 'کل منافع',
nd_total_income: 'کل آمدنی',
nd_total_salaries: 'کل تنخواہیں',
nd_total_purchase: 'کل خریداری',
nd_revenue_or_loss: 'آمدنی / نقصان',
nd_payment_types: 'ادائیگی کی اقسام',
nd_balance: 'بیلنس',
nd_employee_financial_cards: 'ملازمین کے مالی کارڈز',
nd_employees: 'ملازمین',
nd_salary: 'تنخواہ',
nd_pay_advanced: 'ایڈوانس ادائیگی',
nd_deductions: 'کٹوتیاں',
nd_net_paid_salary: 'خالص ادا شدہ تنخواہ',
nd_branch_summary_income_expense: 'برانچ خلاصہ (آمدنی بمقابلہ اخراجات)',
nd_income: 'آمدنی',
nd_expense: 'خرچ',
nd_profit: 'منافع',
nd_loss: 'نقصان',
nd_branch: 'برانچ',
nd_total: 'کل',
nd_month: 'مہینہ',
nd_week: 'ہفتہ',
nd_day: 'دن',
nd_no_date: 'تاریخ نہیں',
nd_expired: 'میعاد ختم',
nd_expiring: 'میعاد قریب',
nd_valid: 'درست',
nd_employee_labor_performance: 'ملازمین کی لیبر کارکردگی',
nd_working: 'کام',
nd_late: 'تاخیر',
nd_total_bill: 'کل بل',
nd_paid: 'ادا شدہ',
nd_remaining: 'بقایا',
nd_vat: 'وی اے ٹی',
nd_view_details: 'تفصیلات دیکھیں',
nd_job_card_details: 'جاب کارڈ کی تفصیلات',
nd_plate: 'پلیٹ',
nd_vehicle: 'گاڑی',
nd_customer: 'کسٹمر',
nd_mobile: 'موبائل',
nd_card_id: 'کارڈ آئی ڈی',
nd_received_date: 'موصولہ',
nd_expected_date: 'متوقع',
nd_status: 'حالت',
nd_under_process: 'عمل میں',
nd_ready_to_collect: 'وصولی کے لیے تیار',
nd_closed: 'بند',
nd_unknown: 'نامعلوم',
nd_unknown_branch: 'نامعلوم برانچ',
nd_work_orders_employee_kpi: 'ورک آرڈرز / ملازم KPI',
nd_attendance_collections: 'حاضری کلیکشن',
nd_periods: 'مدتیں',
nd_metric: 'میٹرک',
nd_working_hours: 'کام کے گھنٹے',
nd_lates: 'تاخیرات',
nd_non_attendance: 'غیر حاضری',
nd_overtime: 'اوور ٹائم',
overtime: 'اوور ٹائم',
pay_overtime: 'اوور ٹائم ادا کریں',
overtime_payment: 'اوور ٹائم ادائیگی',
overtime_payment_failed: 'اوور ٹائم ادائیگی محفوظ نہیں ہو سکی',
full_payment: 'مکمل ادائیگی',
partial_payment: 'جزوی ادائیگی',
payment: 'ادائیگی',
minutes: 'منٹ',
hours: 'گھنٹے',
nd_rewards: 'انعامات',
nd_rewards_hint: 'دیگر انعامات اور ایڈجسٹمنٹس (اوور ٹائم اور غیر حاضری الگ دکھائے جاتے ہیں)',
nd_performance_rating: 'کارکردگی ریٹنگ',
nd_total_job_orders: 'کل جاب آرڈرز',
nd_on_progress: 'جاری',
nd_finished: 'مکمل',
nd_recent_task_snapshot: 'حالیہ ٹاسک خلاصہ',
nd_admin_notes: 'ایڈمن نوٹس',
nd_add_admin_note: 'ایڈمن نوٹ شامل کریں...',
nd_update_note: 'نوٹ اپڈیٹ کریں',
nd_employee_tasks: 'ملازم کے ٹاسک',
nd_task_id: 'ٹاسک آئی ڈی',
nd_task: 'ٹاسک',
nd_due_date: 'آخری تاریخ',
nd_all: 'سب',
nd_active: 'فعال',
nd_on_break: 'بریک پر',
nd_on_leave: 'چھٹی پر',
nd_employee: 'ملازم',
nd_tasks: 'ٹاسکس',
nd_no_tasks_found: 'کوئی ٹاسک نہیں ملا',
nd_monthly: 'ماہانہ',
nd_weekly: 'ہفتہ وار',
nd_daily: 'روزانہ',
att_hr: 'ایچ آر',
att_attendance: 'حاضری',
att_attendance_exception_mgmt: 'حاضری اور استثناء مینجمنٹ',
att_daily_attendance_tracking: 'یومیہ حاضری ٹریکنگ',
att_date: 'تاریخ',
att_employees: 'ملازمین',
att_on_time: 'وقت پر',
att_late: 'تاخیر',
att_absent: 'غیر حاضر',
att_vacation: 'چھٹی',
att_exceptions: 'استثناءات',
att_branch: 'برانچ',
att_shift_start: 'شفٹ شروع',
att_actual_arrival: 'اصل آمد',
att_shift_end: 'شفٹ ختم',
att_actual_departure: 'اصل روانگی',
att_not_attended: 'حاضری نہیں دی',
att_overtime: 'اوور ٹائم',
att_overtime_minutes: 'اوور ٹائم منٹ',
att_absence_type: 'غیر حاضری کی قسم',
att_justification_type: 'جواز کی قسم',
att_reason: 'وجہ',
att_save_attendance: 'حاضری محفوظ کریں',
att_required_field: 'یہ خانہ لازمی ہے',
att_absence_type_required: 'غیر حاضری کی قسم لازمی ہے',
att_justification_type_required: 'جواز کی قسم لازمی ہے',
att_reason_required: 'وجہ لازمی ہے',
att_on_vacation: 'چھٹی پر',
att_permission: 'اجازت',
att_present_on_time: 'حاضر اور وقت پر',
att_late_justified: 'تاخیر (جائز)',
att_late_early_unjustified: 'تاخیر / جلد روانگی (ناجائز)',
att_submit_success: 'حاضری کامیابی سے جمع ہو گئی',
att_backend_pending: 'بیک اینڈ اینڈ پوائنٹ ابھی تیار نہیں، ڈیٹا لاگ کر دیا گیا ہے',
att_justified_delay: 'جائز تاخیر',
att_justified_departure: 'جائز جلد روانگی',
att_unjustified: 'ناجائز',
att_permission_approved_leave: 'اجازت (منظور شدہ رخصت)',
att_not_justified_absent: 'ناجائز (غیر حاضر)',
att_load_employees_failed: 'ملازمین لوڈ نہیں ہو سکے',
att_unknown_branch: 'نامعلوم برانچ',
att_unknown_employee: 'نامعلوم ملازم',
expected_hours: 'متوقع اوقات',
ti_quick_search: 'فوری تلاش',
ti_from_date: 'تاریخ سے',
ti_to_date: 'تاریخ تک',
ti_new_report: 'نئی رپورٹ',
ti_report_header: 'تکنیکی معائنہ رپورٹ',
ti_office_name: 'شیخ المهنہ برائے نقصانات تخمینہ',
ti_report_number: 'رپورٹ نمبر',
ti_date: 'تاریخ',
ti_date_label: 'تاریخ (عیسوی/ہجری)',
ti_status: 'حالت',
ti_status_draft: 'مسودہ',
ti_status_issued: 'جاری شدہ',
ti_status_final: 'حتمی',
ti_vehicle: 'گاڑی',
ti_vehicle_type: 'گاڑی کی قسم',
ti_vehicle_model: 'گاڑی ماڈل',
ti_plate: 'پلیٹ',
ti_plate_number: 'پلیٹ نمبر',
ti_claimant: 'مدعی',
ti_claimant_name: 'مدعی کا نام',
ti_defendant: 'مدعا علیہ',
ti_defendant_name: 'مدعا علیہ کا نام',
ti_commercial_register: 'کمرشل رجسٹر',
ti_cr: 'س.ت',
ti_labor_cost: 'محنت کی لاگت',
ti_labor_cost_sar: 'محنت کی لاگت (ریال)',
ti_labor_cost_numeric: 'محنت کی لاگت عددی',
ti_labor_cost_words: 'محنت کی لاگت الفاظ میں',
ti_actions: 'اقدامات',
ti_edit: 'ترمیم',
ti_delete: 'حذف',
ti_preview_print: 'پیش منظر/پرنٹ PDF',
ti_add_report_title: 'تکنیکی معائنہ رپورٹ شامل کریں',
ti_edit_report_title: 'تکنیکی معائنہ رپورٹ میں ترمیم',
ti_step_vehicle: 'گاڑی کی معلومات',
ti_step_parties: 'دعویٰ کے فریق',
ti_step_findings: 'تکنیکی نتائج',
ti_step_cost_status: 'لاگت اور حالت',
ti_findings_title: 'معائنہ اور تکنیکی نتائج',
ti_add_item: 'آئٹم شامل کریں',
ti_item: 'آئٹم',
ti_save_report: 'رپورٹ محفوظ کریں',
ti_confirm_delete_title: 'حذف کی تصدیق',
ti_confirm_delete_text: 'کیا آپ واقعی رپورٹ نمبر حذف کرنا چاہتے ہیں',
ti_yes_delete: 'ہاں، حذف کریں',
ti_section_vehicle: 'اول: گاڑی کا ڈیٹا',
ti_section_parties: 'دوم: دعویٰ کے فریق',
ti_section_findings: 'سوم: تکنیکی نتائج',
ti_section_financial: 'چہارم: مالی تخمینہ',
ti_type: 'قسم',
ti_model: 'ماڈل',
ti_signature_expert: 'تکنیکی معائنہ ماہر',
ti_signature_approval: 'شیخ کی منظوری',
ti_name_signature: 'نام اور دستخط',
ti_load_failed: 'تکنیکی معائنہ رپورٹس لوڈ نہیں ہو سکیں',
ti_success_title: 'کامیابی',
ti_add_success: 'رپورٹ کامیابی سے شامل ہو گئی',
ti_update_success: 'رپورٹ کامیابی سے اپڈیٹ ہو گئی',
ti_save_failed: 'رپورٹ محفوظ نہیں ہو سکی',
ti_delete_success: 'رپورٹ کامیابی سے حذف ہو گئی',
ti_delete_failed: 'رپورٹ حذف نہیں ہو سکی',
    zi_title: 'ZATCA e-invoicing',
    zi_tab_status: 'Status',
    zi_tab_profile: 'Seller profile',
    zi_tab_connect: 'Connect a device',
    zi_tab_documents: 'ZATCA log',
    zi_mode: 'Sending mode',
    zi_mode_off: 'Off',
    zi_mode_phase1: 'Phase 1 (QR code only)',
    zi_mode_central: 'Central service (old path)',
    zi_mode_inapp: 'From the ERP (Phase 2)',
    zi_environment: 'Environment',
    zi_env_simulation: 'Simulation',
    zi_env_core: 'Production (core)',
    zi_devices: 'Connected devices',
    zi_no_devices: 'No device connected yet',
    zi_branch: 'Branch',
    zi_status: 'Status',
    zi_source: 'Source',
    zi_cert_expires: 'Certificate expires',
    zi_days_left: 'days left',
    zi_icv: 'Invoice counter',
    zi_renew: 'Renew certificate',
    zi_renew_help: 'Enter a new OTP from the Fatoora portal to renew the certificate before it expires',
    zi_counts: 'Documents by status',
    zi_oldest: 'Oldest document not yet accepted',
    zi_hours_old: 'hours old',
    zi_overdue: 'Warning: simplified invoices must be reported to ZATCA within 24 hours of issue',
    zi_key_missing: 'ZATCA_KEY is not set on the server, so no device can be connected',
    zi_schema_missing: 'The ZATCA tables are missing. Run zatca_schema.sql on this database',
    zi_central_note: 'This company still sends through the central service. It is moved with the import tool, which keeps its certificate and invoice chain.',
    zi_activate: 'Start sending from the ERP',
    zi_activate_confirm: 'From now on every new invoice is signed and sent to ZATCA. Continue?',
    zi_zero_title: 'Lines with 0% VAT',
    zi_zero_help: 'Only needed if you sell 0% VAT lines; without it such invoices are not sent',
    zi_zero_category: 'Category',
    zi_zero_code: 'Exemption reason code',
    zi_zero_text: 'Exemption reason text',
    zi_save: 'Save',
    zi_saved: 'Saved',
    zi_seller_name_en: 'Company name (English)',
    zi_seller_name_ar: 'Company name (Arabic)',
    zi_vat: 'VAT number',
    zi_crn: 'Commercial registration',
    zi_street: 'Street (English)',
    zi_building: 'Building number',
    zi_secondary: 'Secondary number',
    zi_district: 'District (English)',
    zi_city: 'City (English)',
    zi_postal: 'Postal code',
    zi_category: 'Business category',
    zi_profile_complete: 'Seller profile is complete',
    zi_profile_help: 'These details go into the device certificate and every invoice. Name and address in English, as registered on Fatoora',
    zi_step1: 'Create the certificate request (CSR)',
    zi_step2: 'Compliance certificate with the OTP from the Fatoora portal',
    zi_step3: 'Compliance checks (6 sample documents)',
    zi_step4: 'Production certificate',
    zi_run: 'Run',
    zi_otp: 'OTP',
    zi_passed: 'Passed',
    zi_failed: 'Failed',
    zi_connected: 'Device connected. Use Start sending on the Status tab',
    zi_doc_type: 'Type',
    zi_invoice: 'Invoice',
    zi_return: 'Return',
    zi_number: 'Number',
    zi_subtype: 'Kind',
    zi_standard: 'Standard',
    zi_simplified: 'Simplified',
    zi_attempts: 'Attempts',
    zi_message: 'Error / warning',
    zi_date: 'Date',
    zi_resend: 'Resend',
    zi_xml: 'Download XML',
    zi_all: 'All',
    zi_search: 'Search invoice number',
    zi_from: 'From',
    zi_to: 'To',
    zi_prev: 'Previous',
    zi_next: 'Next',
    zi_confirm: 'Confirm',
    zi_cancel: 'Cancel',
    zi_close: 'Close',
    zi_st_unsigned: 'Not signed',
    zi_st_pending: 'Waiting to send',
    zi_st_reported: 'Reported',
    zi_st_cleared: 'Cleared',
    zi_st_rejected: 'Rejected',
    zi_st_failed: 'Send failed',
    zi_st_imported: 'Sent earlier',
    zi_st_draft: 'Certificate requested',
    zi_st_compliance: 'Compliance certificate',
    zi_st_active: 'Connected',
    zi_v_title: 'The invoice cannot be saved until the following is corrected (ZATCA requirements):',
    zi_v_line: 'Line',
    zi_v_no_lines: 'The invoice has no items',
    zi_v_line_name_missing: 'the item name is empty',
    zi_v_line_qty_invalid: 'the quantity must be more than zero',
    zi_v_line_amount_mismatch: 'quantity x price = {expected} but the line total is {actual}',
    zi_v_line_vat_rate_unknown: 'VAT rate {actual}% is not a Saudi rate (15%, 5% or 0%)',
    zi_v_line_vat_mismatch: 'VAT should be {expected} but is {actual}',
    zi_v_line_ftotal_mismatch: 'total with VAT should be {expected} but is {actual}',
    zi_v_zero_rate_not_configured: 'A line has 0% VAT but the zero-rate category is not set on the ZATCA screen',
    zi_v_total_exceeds_lines: 'The invoice total before VAT {actual} is more than its items add up to {expected}',
    zi_v_vat_mismatch: 'The invoice VAT should be {expected} (after the discount) but is {actual}',
    zi_v_ftotal_mismatch: 'The invoice total with VAT should be {expected} but is {actual}',
    zi_v_discount_exceeds: 'The discount is larger than the items it applies to',
    zi_v_credit_note_parent_missing: 'The return is not linked to its original invoice',
    zi_v_buyer_vat_invalid: 'The customer\'s VAT number is wrong (15 digits, starting and ending with 3)',
    zi_v_buyer_name_missing: 'The customer name is required on a tax invoice',
    zi_v_buyer_building_invalid: 'The customer\'s building number is required (4 digits)',
    zi_v_buyer_street_missing: 'The customer\'s street is required',
    zi_v_buyer_district_missing: 'The customer\'s district is required',
    zi_v_buyer_city_missing: 'The customer\'s city is required',
    zi_v_buyer_postal_invalid: 'The customer\'s postal code is required (5 digits)',
    zi_v_buyer_secondary_invalid: 'The customer\'s secondary number must be 4 digits',
    zi_v_no_device: 'No ZATCA device is connected for this branch',
    zi_st_needs_data: 'Needs correction',
    zi_st_awaiting_clearance: 'Awaiting clearance',
    zi_page_title: 'ZATCA invoices',
    zi_page_help: 'Every invoice and return and its state at ZATCA. Invoices that need correction or were rejected can be corrected and sent again from here',
    zi_grp_all: 'All',
    zi_grp_sent: 'Sent',
    zi_grp_waiting: 'Waiting',
    zi_grp_attention: 'Needs action',
    zi_customer: 'Customer',
    zi_total: 'Total with VAT',
    zi_reason: 'Reason',
    zi_erp_check: 'ERP check',
    zi_zatca_says: 'ZATCA says',
    zi_fix: 'Correct',
    zi_fix_title: 'Correct the invoice and send it again',
    zi_buyer: 'Customer details',
    zi_buyer_name: 'Customer name',
    zi_items: 'Item names',
    zi_save_resend: 'Save and send again',
    zi_amounts_locked: 'Amounts (quantities, prices, VAT) are not changed here because they are already in the journal entry and stock. If they are wrong, issue a return and then a new, correct invoice',
    zi_now: 'Status now',
    zi_still_problems: 'There are still problems',
    card_payment_invalid: "صفر سے زیادہ ادائیگی زیادہ سے زیادہ دو اعشاری ہندسوں کے ساتھ درج کریں اور درست جاب کارڈ کھولیں۔",
    card_payment_failed: "ادائیگی محفوظ نہیں ہوئی۔ تفصیلات چیک کر کے دوبارہ کوشش کریں۔",
    card_payment_unconfirmed: "کنکشن کی خرابی کے باعث ادائیگی کی تصدیق نہیں ہو سکی۔ دوبارہ ادائیگی سے پہلے کارڈ کھول کر ادائیگیاں چیک کریں۔",
    card_payment_refresh_failed: "ادائیگی محفوظ ہو گئی لیکن کارڈ تازہ نہیں ہو سکا۔ نیا بیلنس دیکھنے کے لیے کارڈ دوبارہ کھولیں؛ ادائیگی دوبارہ جمع نہ کریں۔",
    spare_request_no_data: "کوئی درخواست نہیں",
    spare_request_availability: "دستیابی",
    spare_request_in_stock: "اسٹاک میں دستیاب",
    spare_request_out_of_stock: "اسٹاک میں دستیاب نہیں",
    spare_request_manual_review: "دستی جائزہ درکار ہے",
    spare_request_approve: "منظور کریں",
    spare_request_send_customer: "شامل نہیں - گاہک کو بھیجیں",
    spare_request_create_bill: "خریداری بل بنائیں",
    spare_request_waiting_customer: "گاہک کے جواب کا انتظار ہے",
    spare_request_customer_provided: "گاہک نے پرزہ فراہم کر دیا",
    spare_request_back_pending: "دوبارہ زیر انتظار کریں",
    spare_request_status_pending: "زیر انتظار",
    spare_request_status_approved: "منظور شدہ",
    spare_request_status_rejected: "مسترد شدہ",
    spare_request_status_ordered: "آرڈر کر دیا گیا",
    spare_request_status_fulfilled: "موصول ہو گیا",
    spare_request_status_awaiting_customer: "گاہک کا انتظار",
    spare_request_status_customer_will_provide: "گاہک پرزہ فراہم کرے گا",
    spare_request_confirm_reopen: "کیا اس درخواست کو دوبارہ زیر انتظار کرنا چاہتے ہیں تاکہ اسے منظور یا مسترد کیا جا سکے؟",
    spare_request_bill_id_prompt: "خریداری بل کی آئی ڈی درج کریں (اختیاری)۔ بل سے منسلک کیے بغیر آرڈر درج کرنے کے لیے خالی چھوڑ دیں۔",
    spare_request_price_prompt: "اس پرزے کے لیے گاہک سے وصول کی جانے والی قیمت درج کریں (سعودی ریال):",
    spare_request_invalid_price: "صفر سے زیادہ درست قیمت درج کریں۔",
    spare_request_confirm_essential: "کیا یہ پرزہ کام مکمل کرنے کے لیے ضروری ہے (گاہک اسے متبادل کے بغیر مسترد نہیں کر سکتا)؟\n\nٹھیک ہے = ہاں، ضروری\nمنسوخ = نہیں، اختیاری",
    spare_request_send_failed: "گاہک کو منظوری کی درخواست نہیں بھیجی جا سکی۔",
    spare_request_confirm_provided: "کیا گاہک نے یہ پرزہ خود فراہم کر دیا ہے؟ درخواست منظور ہو جائے گی تاکہ پرزہ ٹیکنیشن کو دیا جا سکے۔",
    checkup_plate_loading: "گاڑی تلاش کی جا رہی ہے…",
    checkup_plate_found: "گاڑی مل گئی؛ محفوظ تفصیلات خالی خانوں میں بھر دی گئیں۔",
    checkup_plate_not_found: "گاڑی نہیں ملی؛ تفصیلات دستی طور پر درج کریں۔",
    checkup_plate_ambiguous: "اس پلیٹ کی ایک سے زیادہ گاڑیاں ہیں؛ تفصیلات بھرنے سے پہلے ریکارڈ چیک کریں۔",
    checkup_plate_failed: "گاڑی تلاش نہیں ہو سکی۔ کنکشن چیک کریں اور دوبارہ تلاش کے لیے پلیٹ کے خانے سے باہر آئیں۔",
    system_login_label: "لاگ ان",
    system_login_invalid: "صارف نام یا پاس ورڈ درست نہیں۔",
    system_login_unavailable: "سسٹم سے رابطہ نہیں ہو سکا۔ کنکشن چیک کر کے دوبارہ کوشش کریں۔",
    purchase_vendor_id_optional: "وینڈر آئی ڈی (اختیاری تلاش)",
    purchase_vendor_required: "بل نمبر اور اشیاء درج کریں۔ نئے وینڈر کے لیے نام اور رابطہ نمبر ضروری ہیں؛ وینڈر آئی ڈی اختیاری ہے۔",
    purchase_vendor_lookup_failed: "وینڈر تلاش نہیں ہو سکا۔ کنکشن چیک کریں اور آئی ڈی یا رابطہ نمبر سے دوبارہ تلاش کریں۔",
    purchase_number_duplicate: "اس وینڈر کے لیے یہ بل نمبر پہلے موجود ہے۔ دوسرا بل نہیں بنایا گیا۔",
    purchase_save_failed: "خریداری بل محفوظ نہیں ہوا۔ تفصیلات چیک کر کے دوبارہ کوشش کریں۔",
    purchase_unconfirmed: "خریداری بل محفوظ ہونے کی تصدیق نہیں ہو سکی۔ دوبارہ جمع کرنے سے پہلے بلوں کی فہرست چیک کریں۔",
    purchase_refresh_failed: "خریداری بل محفوظ ہوا لیکن فہرست تازہ نہیں ہو سکی۔ فہرست دوبارہ کھولیں؛ دوبارہ محفوظ نہ کریں۔",
    zi_view: 'View'
}


  export default urLang;
